<template>
    <div class="form-group" :class="classObject">
        <label v-if="displayLabel === true && getShowRouteName() == null || getShowId() == null" class="control-label col-md-3">
            {{ title }} {{ count }}
        </label>

        <label v-else-if="displayLabel === true" class="control-label col-md-3" >
            <a :href="generateRoute()" target="_blank">
                {{ title }} {{ count }}
                <i class="fa fa-link"></i>
            </a></label>

        <div :class="{ 'col-md-9': displayLabel === true, 'col-md-10': displayLabel === false}">
            <textarea
                    v-if="multiple"
                    :id="id"
                    v-model="text"
                    class="form-control"
                    :maxlength="maxLength"
                    :disabled="disabled"
                    :rows="rows"
            ></textarea>
          <input
v-else
                   :id="id" 
                   v-model="text" 
                   :maxlength="maxLength" 
                   :type="type" 
                   class="form-control" 
                   :disabled="disabled" 
                   :readonly="readonly"
            />
            <span v-if="errorText" class="help-block">
                <p> {{errorText}} </p>
            </span>
        </div>

    </div>
</template>

<script>
import BaseInput from './baseInput.vue'
export default {
  extends: BaseInput,
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Boolean,
      default: false
    },
    displayLabel: {
      type: [Boolean, String],
      default: true
    },
    multiple:  {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    showRouteName: {
      type: String,
      default: null
    },
    showIdParamName: {
      type: String,
      default: 'id'
    },
    showAdditionalParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    maxLength: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      id : `form_${this.name}`,
      text: null,
      errorText: false,
      formGroupClass: 'form-group',
    }
  },
  computed: {
    count() {
      if (this.counter) {
        const textCount = this.text ? this.text.length : 0
        const counterValue = this.maxLength ? (this.maxLength - textCount) : textCount

        return `[${counterValue}]`
      } else {
        return ''
      }
    }
  },
  watch : {
    text: function (value) {
      this.$emit('input', value)
    },
    value: function(v) {
      this.text = v
    },
  },
  mounted: function () {
    if (this.value) {
      this.text = this.value
    }

    this.$emit('input', this.value)
  },
  methods: {
    getShowRouteName() {
      if (this.showRouteName !== null) {
        if (this.showRouteName === false) {
          return null
        }
        return this.showRouteName
      }

      try {
        let params = {}
        params[this.showIdParamName] = this.getShowId()
        Routing.generate(`${this.name}_show`, Object.assign(params, this.showAdditionalParams))
      } catch (err) {
        return null
      }

      return `${this.name}_show`
    },
    generateRoute() {
      let params = {}
      params[this.showIdParamName] = this.getShowId()
      return Routing.generate(this.getShowRouteName(), Object.assign(params, this.showAdditionalParams))
    },
    getShowId() {
      return this.value
    },
    textCount() {
      return this.text ? this.text.length : 0
    }
  },
}
</script>
